import { AdminForm } from "./AdminForm";
import { DiningForm, MustKnowCategoryForm, TravelForm } from "./CategoryForm";
import { ContactForm } from "./ContactForm";
import { FamilyForm } from "./FamilyForm";
import { ManageForm } from "./ManageForm";
import { PaymentsForm } from "./PaymentsForm";
import { PersonalForm } from "./PersonalForm";
import type { EditSection } from "./profileOverlay";
import type { FormProps } from "./types";

export function EditSectionForm({
    section,
    onClose,
}: {
    section: EditSection;
} & FormProps) {
    switch (section) {
        case "manage":
            return <ManageForm onClose={onClose} />;
        case "personal":
            return <PersonalForm onClose={onClose} />;
        case "family":
            return <FamilyForm onClose={onClose} />;
        case "payments":
            return <PaymentsForm onClose={onClose} />;
        case "contact":
            return <ContactForm onClose={onClose} />;
        case "admin":
            return <AdminForm onClose={onClose} />;
        case "dining":
            return <DiningForm onClose={onClose} />;
        case "travel":
            return <TravelForm onClose={onClose} />;
        case "events":
        case "wellness":
        case "shopping":
            return <MustKnowCategoryForm section={section} onClose={onClose} />;
        default: {
            const _exhaustive: never = section;
            return _exhaustive;
        }
    }
}
